App.factory('OAuth', (SERVER_BASE_AUTH_URL, WEBAPP_BASE_URL, OAUTH_CLIENT_ID, $fetch)  => ({
  getToken(authorizationCode) {
    return $fetch({
      baseUrl: SERVER_BASE_AUTH_URL,
      url: '/oauth/token',
      method: 'POST',
      body: {
        code: authorizationCode,
        'grant_type': 'authorization_code',
        'client_id': OAUTH_CLIENT_ID,
        'redirect_uri': this.getRedirectUri()
      }
    })
  },
  revoke(accessToken) {
    const authorization = window.btoa(`${OAUTH_CLIENT_ID}`)
    return $fetch({
      baseUrl: SERVER_BASE_AUTH_URL,
      url: '/oauth/revoke',
      method: 'POST',
      headers: {
        'Authorization': `Basic ${authorization}`
      },
      body: {
        token: accessToken
      }
    })
  },
  getRedirectUri() {
    const url = new URL(window.location.href)
    url.searchParams.delete("code")
    url.searchParams.delete("state")
    return url.toString()
  }
}))
